import { binariesReducer, BinariesState } from './binaries.reducer';
import { latestReducer, LatestState } from './latest.reducer';

export interface BinariesFeatureState {
  binaries: BinariesState;
  latest: LatestState;
}

export const BINARIES_FEATURE_KEY = 'binaries';
export const binariesFeatureReducer = {
  binaries: binariesReducer,
  latest: latestReducer,
};

export * from './latest.reducer';
